import React, { useContext, useState } from 'react';
import { useCredentials } from './CredentialsContext';
import { AuthContext } from '../auth/authContext';
import { Link } from 'react-router-dom';

const CredentialsForm: React.FC = () => {
    const { id, secret } = useContext(AuthContext);

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        const input = document.querySelector('input[name="secret"]') as HTMLInputElement;
        input.type = input.type === 'password' ? 'text' : 'password';
        setIsPasswordVisible(!isPasswordVisible);
    };

    return (
        <div className='d-flex flex-column px-3' style={{ width: '420px' }}>
            <div className="form-group">
                <label
                    className="form-label bolder"
                    htmlFor="customerId"
                >
                    username
                </label>
                <input
                    className="form-control"
                    name={"CustomerId"}
                    placeholder="Customer ID"
                    type="text"
                    disabled
                    value={id || ""}
                />
            </div>
            <div className="form-group">
                <label
                    className="form-label bolder"
                    htmlFor="secret"
                >
                    password
                </label>
                <div style={{ position: 'relative' }}>
                    <input
                        className="form-control"
                        type="password"
                        name="secret"
                        disabled
                        value={secret || ""}
                    />
                    <button
                        type="button"
                        className="btn btn-link position-absolute"
                        style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}
                        onClick={togglePasswordVisibility}
                    >
                        {
                            isPasswordVisible ? <i className="fe fe-eye-off"></i> : <i className="fe fe-eye"></i>
                        }
                    </button>
                </div>
                <p className="text-muted mt-2">
                    this password is configurable in the <Link className='text-primary' to="/settings/dahab-credentials">Account Settings</Link> page.
                </p>
            </div>
        </div>
    );
};

export default CredentialsForm;
